<section class="contact-section" id="contacto">
  <!-- <div class="container"> -->

    <!-- Header -->
    <div class="contact-header" data-aos="fade-up" data-aos-duration="1000">
      <app-badge text="Estamos Aquí"></app-badge>
      <h2 class="section-title">¡Contáctanos!</h2>
      <p class="section-desc">¿Tienes dudas o quieres realizar una cotización? Escríbenos, estamos listos para ayudarte en cada paso de tu proyecto.</p>
    </div>

    <!-- Two-column layout -->
    <div class="contact-grid">

      <!-- Left: Map -->
      <div class="map-col" data-aos="fade-right" data-aos-delay="100" data-aos-duration="800">
        <div class="map-wrapper">
          <button
            *ngIf="!showMap"
            type="button"
            class="submit-btn"
            (click)="enableMap()"
          >
            Cargar mapa
          </button>
          <iframe
            *ngIf="showMap"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3771.5707162897975!2d-98.241099!3d19.038629!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc73d302e73e1%3A0x25999e4fb5188e60!2sPlaza%20Comercial%20San%20Jos%C3%A9!5e0!3m2!1ses!2smx!4v1756848539562!5m2!1ses!2smx"
            style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            title="Ubicación Plaza San José"></iframe>
        </div>
        <!-- Contact quick info -->
        <!-- <div class="map-info">
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <span>Monterrey, Nuevo León, México</span>
          </div>
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Lun – Vie: 9:00 am – 6:00 pm</span>
          </div>
        </div> -->
      </div>

      <!-- Right: Form -->
      <div class="form-col" data-aos="fade-left" data-aos-delay="200" data-aos-duration="800">
        <div class="form-card">
          <div class="form-header">
            <h3 class="form-title">Envíanos un mensaje</h3>
            <p class="form-subtitle">Completa el formulario y nos pondremos en contacto contigo lo antes posible.</p>
          </div>

          <form [formGroup]="contactForm" (ngSubmit)="formValidation()">
            <div class="form-fields">

              <div class="field-group">
                <label class="field-label" for="contact-name">Nombre completo</label>
                <div class="field-input" [class.field-error]="(contactForm.get('name')?.errors && contactForm.get('name')?.touched) || (invalid && contactForm.get('name')?.untouched)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  <input id="contact-name" placeholder="Tu nombre" type="text" required (click)="resetValidations()" formControlName="name" />
                </div>
                <p class="error-msg" [@enterAnimation]
                  *ngIf="(contactForm.get('name')?.errors && contactForm.get('name')?.touched) || (invalid && contactForm.get('name')?.untouched)">
                  {{ errorMessage('name') }}
                </p>
              </div>

              <div class="field-group">
                <label class="field-label" for="contact-phone">Teléfono</label>
                <div class="field-input" [class.field-error]="(contactForm.get('phone')?.errors && contactForm.get('phone')?.touched) || (invalid && contactForm.get('phone')?.untouched)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                  <input id="contact-phone" placeholder="(81) 1234 5678" type="text" required (click)="resetValidations()" formControlName="phone" oninput="(value=value.replace(/\D+/g, ''))" />
                </div>
                <p class="error-msg" [@enterAnimation]
                  *ngIf="(contactForm.get('phone')?.errors && contactForm.get('phone')?.touched) || (invalid && contactForm.get('phone')?.untouched)">
                  {{ errorMessage('phone') }}
                </p>
              </div>

              <div class="field-group">
                <label class="field-label" for="contact-comments">Mensaje</label>
                <div class="field-input field-textarea" [class.field-error]="(contactForm.get('comments')?.errors && contactForm.get('comments')?.touched) || (invalid && contactForm.get('comments')?.untouched)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                  <textarea id="contact-comments" placeholder="Cuéntanos sobre tu proyecto..." required (click)="resetValidations()" formControlName="comments"></textarea>
                </div>
                <p class="error-msg" [@enterAnimation]
                  *ngIf="(contactForm.get('comments')?.errors && contactForm.get('comments')?.touched) || (invalid && contactForm.get('comments')?.untouched)">
                  {{ errorMessage('comments') }}
                </p>
              </div>

            </div>

            <button class="submit-btn" type="submit" [class.is-loading]="isLoading" [disabled]="isLoading">
              <ng-container *ngIf="isLoading; else normal">
                <i class="pi pi-spin pi-spinner"></i>
              </ng-container>
              <ng-template #normal>
                <span>Enviar Mensaje</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              </ng-template>
            </button>
          </form>
        </div>
      </div>

    <!-- </div> -->
  </div>
</section>
